import { ContactDetail } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/enums";

export const CONTACTS_SELECTION_RESULTS_LIMIT = 10000;

export const CONTACTS_DETAILS_LIST = [
    ContactDetail.Email,
    ContactDetail.MobilePhone,
    ContactDetail.DirectPhone,
    ContactDetail.EmailAndMobilePhone,
];
